import { Box, Typography } from '@mui/material';

import RunSummaryAgentList from './RunSummaryAgentList';
import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function QualityInsights({ items = [] }) {
  if (!items.length) return null;

  return (
    <Box sx={runSummaryAgentReportStyles.reportPanel}>
      <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitle}>
        Quality Insights
      </Typography>
      <Box sx={runSummaryAgentReportStyles.insightStack}>
        {items.map((item, index) => (
          <Box
            key={`${item.title || 'insight'}-${index}`}
            sx={runSummaryAgentReportStyles.insightItem}
          >
            <Typography variant="body2" sx={runSummaryAgentReportStyles.insightTitle}>
              {item.title || `Insight ${index + 1}`}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {item.interpretation}
            </Typography>
            <RunSummaryAgentList items={item.evidence || []} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
